import { FilterDocument } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';

export const useUpdateInboxFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: FilterDocument) =>
      updateSettings({
        filters: {
          inbox: filterDocument,
        },
      }),
    [updateSettings],
  );
};
